import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { ChatBotProvider } from '@/contexts/ChatBotContext'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import { CookieConsent } from '@/components/CookieConsent'
import { LanguageRouter } from '@/components/LanguageRouter'
import { AuthProvider, useAuth } from '@/contexts/AuthContext'
import { AdminLogin, AdminDashboard } from '@/pages/admin'

const AdminMockup = lazy(async () => ({ default: (await import('@/pages/admin/AdminMockup')).AdminMockup }))

function PublicOverlays() {
  const { pathname } = useLocation()
  if (pathname.startsWith('/admin/')) return null
  return <><Suspense fallback={null}><ChatBot /></Suspense><CookieConsent /></>
}

const ChatBot = lazy(async () => ({ default: (await import('@/components/ChatBot')).ChatBot }))

function ProtectedAdminDashboard() {
  const { user, loading } = useAuth()
  if (loading) return null
  return user ? <AdminDashboard /> : <Navigate to="/admin/login" replace />
}

function AdminRoutes() {
  return (
    <Routes>
      <Route path="mockup/*" element={<Suspense fallback={null}><AdminMockup /></Suspense>} />
      <Route path="login" element={<AdminLogin />} />
      <Route path="dashboard" element={<ProtectedAdminDashboard />} />
      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CookieConsentProvider>
          <ChatBotProvider>
            <Routes>
              <Route path="/admin/*" element={<AdminRoutes />} />
              <Route path="/*" element={<LanguageRouter />} />
            </Routes>
            <PublicOverlays />
          </ChatBotProvider>
        </CookieConsentProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}
